export interface ShouldShowVideoOnlyLayoutParams {
  availableVideoCount: number;
  hasTelemetryData: boolean;
  telemetryMissing: boolean;
  isLoading: boolean;
}

/**
 * Video-only "center stage" layout applies when videos exist, telemetry is
 * definitively absent (404 with no other telemetry errors), and loading has
 * settled (so the layout does not flash during initial fetches).
 *
 * Only the visualization-data loading flag gates this (not the metadata/summary
 * flags): a 404 settles fast and does not retry, so genuine video-only sessions
 * get the correct layout sooner; the rare late metadata success simply reflows
 * the page back to the 3-pane layout.
 */
export function shouldShowVideoOnlyLayout(
  params: ShouldShowVideoOnlyLayoutParams,
): boolean {
  return (
    params.availableVideoCount > 0 &&
    !params.hasTelemetryData &&
    params.telemetryMissing &&
    !params.isLoading
  );
}
